/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { requestsReducer } from '../utilities/redux-request-deduplication';

import applications from './applications';
import calendar from './calendar';
import journeyTemplateEvents from './journey-templates-events';
import localization from './localization';
import permissions from './permissions';
import businessRules from './business-rules';
import recentAutomationsRun from './recent-automations-run';
import recentEmailsEdited from './recent-emails-edited';
import recentEmailsSent from './recent-emails-sent';
import recentJourneysEdited from './recent-journeys-edited';
import salesforceBlogPosts from './salesforce-blog-posts';
import welcomeMat from './welcome-mat';

const rootReducer = combineReducers({
  routing: routerReducer,
  requests: requestsReducer,
  applications,
  calendar,
  journeyTemplateEvents,
  localization,
  permissions,
  businessRules,
  recentAutomationsRun,
  recentEmailsEdited,
  recentEmailsSent,
  recentJourneysEdited,
  salesforceBlogPosts,
  welcomeMat,
});

export default rootReducer;
